import { IncidentSchema } from "@redotech/redo-model/incidents/incident";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getIncident = {
  name: "getIncident" as const,
  input: z.object({ incidentId: zExt.objectId() }),
  output: z.object({ incident: IncidentSchema }),
};
